import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const Diamond = createSvgIcon(
  () => (
    <path d="M40.9167 0H34.25L40 13.3333H48.5L40.9167 0ZM30.25 0H18.6667L12.9167 13.3333H36L30.25 0ZM8 0L0.5 13.3333H8.91667L14.6667 0H8ZM0.5 16L18.6667 37.25C18.9167 37.5 19.25 37.25 19.0833 37L8.83333 16H0.5ZM12.8333 16L24.25 42.5833C24.3333 42.75 24.5833 42.75 24.6667 42.5833L36.0833 16H12.8333ZM29.8333 37C29.6667 37.25 30.0833 37.5 30.25 37.25L48.5 16H40.0833L29.8333 37Z" />
  ),
  '0 0 49 43',
  'Diamond'
);
